import { render, staticRenderFns } from "./icon-html.vue?vue&type=template&id=4a94aa7b&"
import script from "./icon-html.vue?vue&type=script&lang=js&"
export * from "./icon-html.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports